import React, { useEffect, useState } from 'react'
import '../../../../../../scss/pages/Attendance/Component/Asset/Assets/AssetGroup/assetGroup.scss'
import LeftArrow from '../../../../../../asset/svg/leftArrow.svg';
import { useNavigate } from 'react-router';
import { AGREEMENT_PATH, ASSET_SELECT_STORE_PATH, DE_REGISTERED_ASSET_PATH, DOWNLOAD_QR_PAGE_PATH, REGISTERED_ASSET_EFFECTIVE_DATE_PATH } from '../../../../../../utils/Constants';
import { Chip, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useDispatch, useSelector } from 'react-redux';
import { GET_AGREEMENT_LATEST_DATA, GET_ISSUED_STORE_DOWNLOAD_QR, GET_REGISTER_ASSET_PURCHASE_DATA, HIDE_MODAL_ASSETGROUP, SHOW_MODAL_SELECT_ITEM, SHOW_MODAL_SELECT_STORE } from '../../../../../../sagas/type';
import { getLocalStoreString } from '../../../../../../utils/Helper';

function Asset(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [AgreementData, setAgreementData] = useState([]);
    const [isThereEffectiveDate, setThereEffectiveDate] = useState(false);
    const { selectData } = props;
    const { AgreementDraftData, SelectedStoreDatas, IssuedStoreDataDownloadQr } = useSelector(mapStateToProps);
    useEffect(() => {
        const storeCode = getLocalStoreString("storeCode");
        dispatch({
            type: GET_AGREEMENT_LATEST_DATA,
            payload: storeCode,
        })
    }, [AgreementData])

    useEffect(() => {
        const TenantId = getLocalStoreString("CompanyID");
        dispatch({
            type: GET_REGISTER_ASSET_PURCHASE_DATA,
            TenantId: TenantId,
        });
    }, [])

    useEffect(() => {
        setAgreementData(AgreementDraftData)
    }, [AgreementData])
    const handleBack = () => {
        dispatch({ type: HIDE_MODAL_ASSETGROUP })
        // dispatch({ type: SHOW_MODAL_SELECT_STORE })
        navigate(ASSET_SELECT_STORE_PATH)
    }

    useEffect(() => {
        const code = SelectedStoreDatas && SelectedStoreDatas.length && SelectedStoreDatas[0]?.code;
        dispatch({
            type: GET_ISSUED_STORE_DOWNLOAD_QR,
            payload: { storeCode: code },
        })
    }, [])

    useEffect(() => {
        if (IssuedStoreDataDownloadQr && IssuedStoreDataDownloadQr.length) {
            const isAvailableEffectiveDate = [...IssuedStoreDataDownloadQr]
            const hasValue = isAvailableEffectiveDate?.every(obj => obj?.effectiveDate !== "")
            setThereEffectiveDate(hasValue);
        }
    }, [IssuedStoreDataDownloadQr])

    const [assetData, setAssetData] = useState([
        { name: 'Register New Asset', type: 'Register New Asset', assetGroup: false, selectItem: true },
        { name: 'Agreement', type: 'Agreement', pending: "Pending", rejected: 'Rejected', inReview: 'In Review', approved: 'Approved', },
        { name: 'Download QR', type: 'Download QR' },
        { name: 'De-Register Asset', type: 'De-Register Asset' },
    ])

    const cardClickToNavigate = (data) => {
        const { name, assetGroup, selectItem } = data;
        switch (name) {
            case 'Register New Asset':
                dispatch({ type: HIDE_MODAL_ASSETGROUP })
                dispatch({ type: SHOW_MODAL_SELECT_ITEM })
                break;
            case 'Agreement':
                if (!isThereEffectiveDate) {
                    navigate(REGISTERED_ASSET_EFFECTIVE_DATE_PATH)
                } else {
                    navigate(AGREEMENT_PATH, { state: { selectData: selectData } });
                }
                break;
            case 'Download QR':
                navigate(DOWNLOAD_QR_PAGE_PATH, { state: { selectData: selectData } });
                break;
            case 'De-Register Asset':
                navigate(DE_REGISTERED_ASSET_PATH);
            default:
                break;
        }
    }

    return (
        <div className='AssetGroup-Container'>
            <div className='AssetGroup-Container_header'>
                <div>
                    <img className='AssetGroup-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='AssetGroup-Container_header_content'>{SelectedStoreDatas && SelectedStoreDatas?.length > 0 && SelectedStoreDatas[0]?.name}</span>
                </div>
            </div>
            <div className='AssetGroup-Container_card-container'>
                {assetData.map((data) => {
                    return (
                        <Box key={data?.name} onClick={() => cardClickToNavigate(data)} sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '1rem', marginBottom: '10px', display: "flex", justifyContent: "space-between", alignItems: "center   " }}>
                            <Typography sx={{ color: '#FFF', fontWeight: 600, fontSize: '12px' }}>{data.name}</Typography>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {AgreementDraftData?.signedFiles?.length == 0 && data?.pending &&
                                    AgreementDraftData?.workflowStatus == 'NONE' && <Stack direction="row" spacing={1} className='AssetGroup-Container_Stock-chip' sx={{ height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", border: "0.5px solid #FF7272", background: "rgba(255, 114, 114, 0.20)" }}>
                                        <Chip label={data?.pending} className='AssetGroup-Container_Store-chip' sx={{ color: "#FF7272", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                                    </Stack>}
                                {AgreementDraftData?.signedFiles?.length > 0 && data?.rejected &&
                                    AgreementDraftData?.workflowStatus == 'REJECTED' && <Stack direction="row" spacing={1} className='AssetGroup-Container_Stock-chip' sx={{ height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", border: "0.5px solid #FF7272", background: "rgba(255, 114, 114, 0.20)" }}>
                                        <Chip label={data?.rejected} className='AssetGroup-Container_Store-chip' sx={{ color: "#FF7272", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                                    </Stack>}
                                {AgreementDraftData?.signedFiles?.length > 0 && data?.inReview &&
                                    AgreementDraftData?.workflowStatus == 'IN_REVIEW' && <Stack direction="row" spacing={1} className='AssetGroup-Container_Stock-chip' sx={{ height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", border: "0.5px solid #EAA439", background: "rgba(234, 164, 57, 0.20)" }}>
                                        <Chip label={data?.inReview} className='AssetGroup-Container_Store-chip' sx={{ color: "#EAA439", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                                    </Stack>}
                                {AgreementDraftData?.signedFiles?.length > 0 && data?.approved &&
                                    AgreementDraftData?.workflowStatus == 'APPROVED' && <Stack direction="row" spacing={1} className='AssetGroup-Container_Stock-chip' sx={{ height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%", border: "0.5px solid #6FDF97", background: "rgba(111, 223, 151, 0.20)" }}>
                                        <Chip label={data?.approved} className='AssetGroup-Container_Store-chip' sx={{ color: "#6FDF97", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                                    </Stack>}
                                <ArrowForwardIosIcon sx={{ color: "white", fontSize: 15 }} />
                            </div>
                        </Box>
                    )
                })}

            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        AgreementDraftData: state?.attendanceConfig?.AgreementDraftData,
        showModalSlectItem: state?.attendanceConfig?.showModalSlectItem,
        shoModalAssetGroup: state?.attendanceConfig?.shoModalAssetGroup,
        SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
        IssuedStoreDataDownloadQr: state?.attendanceConfig?.IssuedStoreDataDownloadQr,
    }
}

export default Asset